import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { VIDEO_ANIMATION_CONFIG, VIDEO_SCREENS } from '../Video.constants';
import { useEffect } from 'react';
import { VideoProps } from '../Video';
import { getVideoNavigations } from '../Video.navigations';

/**
 * Add photo left panel navigation animation configs
 */
export const useAddVideoNavigations = (props: VideoProps) => {
  const { screens, addNavigations } = useNavigationPaneContext();
  const videoNavigations = getVideoNavigations({ ...props });
  useEffect(() => {
    if (!screens.includes(VIDEO_SCREENS[0])) {
      addNavigations(VIDEO_SCREENS, VIDEO_ANIMATION_CONFIG, videoNavigations);
    }
  }, [addNavigations, screens, videoNavigations]);
};
